var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _text, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _text2, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _text3, _path295, _path296, _path297, _path298, _path299, _text4, _path300, _text5, _path301, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#fff}.st2{fill:#999}.st3{fill:#bfbfbf}.st4{fill:#ccc}.st5{fill:#4d4d4d}.st6{font-family:&apos;ArialMT&apos;}.st7{font-size:6.6895px}.st8{fill:#369;fill-opacity:.502}.st9{font-size:12.2472px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.9 50.4c-1.1-.4-2.3-.6-3.4-.6-4 .1-6.9 2.2-8.7 6.1l-14.2 36.4 71.9 28 14.2-36.4c1.6-5.6-.2-9.8-5.4-12.3l-54.4-21.2z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.5 84.2c.4-1.3.6-2.5.6-3.8-.2-4.3-2.4-7.5-6.5-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.6.2-7.8 2.4-9.6 6.5l-14.2 36.6-.2.8 73.4 28.4.4-.6 14.3-36.6m-1-3.7c0 1-.2 2.1-.6 3.1L284 119.3 213.5 92l13.9-35.9c1.7-3.5 4.4-5.3 8.2-5.4 1 0 2.1.2 3.1.6L293 72.5c3.5 1.6 5.3 4.3 5.5 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.3 76.6l-47-18.2-5.4 14.2 47 18.2 5.4-14.2z",
    className: "st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.3 91.9l5.9-14.8.2-.8-47.7-18.6-.8-.2-5.9 14.8-.2.8.6.4 47 18.2.9.2m3.9-14.7L282.4 90 237 72.2l4.8-12.5 45.4 17.5zM302 96.7l-.2-1.7-9.6.8.2 1.7 9.6-.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5 92.2l-6.5-2.5-5 13 6.5 2.5 5-13z",
    className: "st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 91.7l-.8-.4-6.5-2.5-.8-.2-.2.8-5 13-.4.6.8.4 6.5 2.5.8.4.2-.8 5.2-13 .2-.8m-6.5 12.5l-5-2.1 4.4-11.3 5 1.9-4.4 11.5zM223.4 69.2L217 62l-1.3 1 6.5 7.3 1.2-1.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 58.7l-6.5-2.5-5.2 13 6.5 2.5 5.2-13z",
    className: "st1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.3 58l-.8-.2-6.5-2.5-.8-.4-.2.8-5 13-.4.8.8.4 6.5 2.5.8.2.2-.8 5-13 .4-.8m-6.6 12.5l-5-1.9 4.4-11.5 5 1.9-4.4 11.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.4 102.4l-7.9 20.7 28.4 16.3 32 7.3 7.9-20.7-60.4-23.6z",
    className: "st2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M268.7 146.9l7.9-20.7.4-.8-.8-.2-60.4-23.6-.8-.2-.2.8-8.4 21.3.6.4 28.4 16.1h.2l32 7.3.6.2.5-.6m6.2-20.6l-7.6 19.3-30.9-7.1-27.8-15.7 7.4-19.3 58.9 22.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M280.3 133.7l-15.9-6.1-12.1 31.4 15.7 6 12.3-31.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.7 133.5l-.4-.2-15.7-6.1-.4-.2-.2.4-12.2 31.6-.2.2.4.2 15.7 6.1.4.2.2-.4 12.1-31.4.3-.4m-13.1 31.2l-14.7-6 11.7-30.5 15.1 5.9-12.1 30.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.9 133.1l-.8-.2-12.1 31.4.6.4 12.3-31.6zM276.8 132.5l-.6-.2-12.3 31.4.8.4 12.1-31.6zM275.3 131.9l-.8-.4-12.1 31.6.6.2 12.3-31.4zM273.6 131.2l-.8-.4-12.3 31.6.8.2 12.3-31.4zM271.6 130.4l-.8-.2-12.1 31.4.8.4 12.1-31.6zM269.9 129.8l-.8-.4-12.3 31.6.8.2 12.3-31.4zM268.2 129.1l-.8-.4-12.1 31.6.8.2 12.1-31.4zM266.5 128.3l-.8-.2-12.3 31.4.8.4 12.3-31.6z",
    className: "st3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 111.1l-15.7-6.1-12.3 31.4 15.7 6.1 12.3-31.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.6 110.9l-.2-.2-15.9-6.1-.2-.2-.2.4-12.3 31.6v.2l.2.2 15.9 6.1.2.2.2-.4 12.3-31.4v-.4m-13.1 31.2l-14.7-5.9 11.9-30.6 14.8 5.9-12 30.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.6 110.6l-.6-.2-12.3 31.4.8.4 12.1-31.6zM219.1 109.9l-.8-.2-12.1 31.4.6.4 12.3-31.6zM217.2 109.3l-.6-.4-12.3 31.6.8.2 12.1-31.4zM215.4 108.6l-.8-.4-12.1 31.6.6.2 12.3-31.4zM213.6 107.8l-.6-.2-12.4 31.4.8.4 12.2-31.6zM211.9 107.2l-.8-.4-12.1 31.6.6.2 12.3-31.4zM210.2 106.5l-.8-.4-12.4 31.5.8.2 12.4-31.3zM208.4 105.7l-.8-.2-12.1 31.4.8.4 12.1-31.6z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.4 133c-.6-.3-1.3-.4-2-.4-2.3.1-3.9 1.2-4.9 3.3-.8 3.1.2 5.4 3.1 6.9.6.2 1.3.3 1.9.3 2.2-.1 3.8-1.3 4.8-3.4.9-3.2-.1-5.4-2.9-6.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 139.8c.2-.6.3-1.3.4-2.1-.1-2.4-1.3-4.2-3.6-5.2-.8-.3-1.5-.5-2.1-.4-2.5.1-4.3 1.3-5.4 3.6-.2.8-.3 1.5-.4 2.1.1 2.4 1.4 4.3 3.8 5.4.6.2 1.3.3 2.1.4 2.4-.1 4.2-1.4 5.2-3.8m-5.2-6.9c.6-.1 1.1 0 1.7.2 2 1 3.1 2.5 3.1 4.6.1.6-.1 1.3-.4 1.9-.8 2-2.3 3.1-4.4 3.1-.6 0-1.3-.1-1.9-.4-2-.9-3.1-2.4-3.1-4.6 0-.6.1-1.1.4-1.7.9-1.9 2.4-3 4.6-3.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.6 75.2l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234.6 74.6l-.8-.2-12.1-4.8-.4.8-1.9 4.6-.2.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1l-1.1 3.1-9.9-3.8 1.3-3.1 9.7 3.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1 79.5l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.8 85.3l2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2L243 85l.8.3m.1-5.1l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.6 84l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6 83.6l-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9l-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268 88.6L256.5 84l-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M267.1 93.5l2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.4l-1 3-10-3.8 1.3-3 9.7 3.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 93L268 88.6l-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M280.6 92.5l-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9l-1.1 3.1-10-4 1.3-3 9.8 3.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.1 97.6L279.6 93l-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M291.9 97.8l.2-.8-12.3-4.6-.6-.4-.4.8-1.7 4.6-.4.8.8.2L289 103l.8.2.2-.8 1.9-4.6m-1.9.1l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M229.2 68.1l-5.4-2.1-1.7 4.6 5.2 2.1 1.9-4.6z",
    className: "st4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M230.2 67.7l-.8-.4-5.2-2.1-.8-.2-.2.8-1.9 4.6-.2.8 6.7 2.5.4-.8 1.7-4.6.3-.6m-7 2.5l1-3 3.7 1.5-1.1 2.9-3.6-1.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M240.7 72.5l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 72.1l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.9m-2.2.9l-1.3 3-9.9-3.9 1.1-2.9 10.1 3.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.2 77.1l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M253.2 76.5l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7 81.5l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M264.7 81.1l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2.9l-1.3 3-9.8-3.9 1-3.1 10.1 4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M275.2 86.1l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M276.2 85.5l-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8.8.2 11.5 4.4.6.4.4-.8 1.9-4.6.2-.8m-2.2.9l-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.7 90.4L275.2 86l-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 96.1l2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 11.5 4.6.8.3m.1-5.1l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M292.9 92.9l-6.3-2.5L285 95l6.1 2.5 1.8-4.6z",
    className: "st4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294 92.3l-.8-.2-6.1-2.5-.8-.2-.4.8-1.7 4.6-.4.6.8.4 6.3 2.3.6.4.4-.8 1.7-4.6.4-.8m-7.9 2.2l1.1-2.9 4.6 1.7-1.3 3-4.4-1.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 65.8l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.1 66.3l.2-.8-13-5-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 2-4.6m-1.9.1l-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M248.7 70.4l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M249.6 70.6l.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.1l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M260.3 74.8l-11.5-4.4-1.9 4.6 11.7 4.4 1.7-4.6z",
    className: "st4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M259 80.4l2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1l-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M271.8 79.3l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 79.6l.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M283.2 83.8l-11.5-4.4L270 84l11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M282 89.3l2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.3-5.1l-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M294.7 88.2l-11.5-4.4-1.7 4.6L293 93l1.7-4.8z",
    className: "st4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M295.6 88.6l.2-.8-12.2-4.8-.8-.2-.2.8-1.9 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 2-4.6m-1.8.1l-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M232.9 58.9l-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    className: "st4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M233.9 58.3l-.8-.2-5.2-2.1-.8-.2L225 61l-.2.8.8.4 5.2 1.9.8.4.2-.8 1.9-4.6.2-.8m-7.1 2.6l1.1-3 3.8 1.5-1 3-3.9-1.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M244.3 63.3l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M243.1 68.9l2.3-6.1-.8-.4-11.6-4.3-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.9.2m.1-5.1l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M255.8 67.7l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9 67.3l-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1l-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M267.3 72.3l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3 77.1l2.1-5.2-.8-.4-11.6-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.3-.8m-.1-4.4l-1 3-10-3.8 1.3-3 9.7 3.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M278.8 76.7l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M279.9 76.3l-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9l-1.1 3.1-10-4 1.3-3 9.8 3.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M290.4 81.2l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M291.2 81.5l.2-.8-12.3-4.7-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.5m-1.9.1l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M296.6 83.6l-6.3-2.3-1.7 4.6 6.1 2.3 1.9-4.6z",
    className: "st4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M297.7 83.2l-.8-.2-6.1-2.5-.8-.2-2.1 5.2-.2.8.6.4 6.3 2.3.8.4.2-.8 1.9-4.6.2-.8m-8 2.2l1.1-3.1 4.6 1.9-1 3.1-4.7-1.9z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M240.7 56.6l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M239.4 62.3l2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.4 11.5 4.4.8.2m.3-5.1l-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M252.2 61l-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    className: "st4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M253.4 60.6l-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.8m-2.2.9l-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7 65.6L252.2 61l-1.7 4.8 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M264.9 65.2l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.2-.8 1.9-4.6.4-.6m-2.3.9l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M275.2 69.9l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M276.5 69.5l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.9m-2.2 1l-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M286.7 74.6L275.2 70l-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M288 74l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M298.4 78.9l-11.7-4.4-1.7 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M299.5 78.6l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1l-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M264.1 125.2l-39.7-15.5-6.5 18.2 38.5 15.1 7.7-17.8z",
    className: "st5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M255.5 133.9l-29.9-11.7-2.3 6.1 29.9 11.5 2.3-5.9z",
    className: "st1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7",
    transform: "matrix(.9321 .3625 -.3625 .932 224.0566 127.4501)"
  }, "\n    L521 GHF\n  ")), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6 102.7l75.5 29.3-1.5 9 12.5-37.4L217.3 74l-15.9 36 5.2-7.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M290.6 104.7l-72.3-28-4.6 19.9 66.9 26.1 10-18z",
    className: "st2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M340.5 89.9c-1.2-.4-2.4-.6-3.6-.6-4.1.1-7 2.2-8.8 6.1L314 131.7l72.1 28 14.2-36.4c1.5-5.6-.3-9.8-5.4-12.3l-54.4-21.1z",
    className: "st1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M400.9 123.7c.6-1.3.8-2.5.8-3.8-.1-4.5-2.4-7.7-6.7-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.4.1-7.6 2.3-9.6 6.5l-14 36.6-.4.6.8.4 71.9 28 .8.2 14.6-37.2m-.8-3.7c0 1-.2 2.1-.6 3.1l-13.9 35.6-70.4-27.4L329 95.7c1.6-3.5 4.3-5.3 7.9-5.4 1 0 2.1.2 3.1.6l54.4 21.1c3.7 1.6 5.6 4.3 5.7 8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M389.9 116.2l-47-18.2-5.6 14.2 47 18.2 5.6-14.2z",
    className: "st1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M391 115.7l-.8-.4-47-18.2-.6-.4-.4.8-5.4 14.2-.4.8.8.2 47.7 18.6.4-.6 5.4-14.2.3-.8m-2.2.9l-4.9 12.5-45.5-17.6 5-12.6 45.4 17.7zM403.4 136.2v-1.7l-9.6.8v1.7l9.6-.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M408.7 131.7l-6.5-2.5-5 13 6.5 2.5 5-13z",
    className: "st1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M409.6 131.9l.4-.6-.8-.4-6.5-2.5-.8-.2-5.6 14.4.8.4 6.5 2.5.8.2 5.2-13.8m-6.3 11.6l-4.9-1.9 4.4-11.3 4.9 1.9-4.4 11.3zM324.7 108.7l-6.3-7.1-1.3 1 6.3 7.1 1.3-1z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M322.6 98.2l-6.5-2.7-5 13.2 6.5 2.5 5-13z",
    className: "st1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 98.4l.2-.8-7.1-2.7-.8-.4-.4.8-5 13-.2.8 7.9 3.1.4-.8 5-13m-6.4 11.6l-4.8-1.9 4.4-11.5 4.8 1.9-4.4 11.5z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M317.3 142.1l-7.9 20.7 28.4 16.1 32 7.3 7.9-20.7-60.4-23.4z",
    className: "st2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M370.7 186.5l7.9-20.7.4-.6-.8-.4-60.4-23.4-.8-.4-.2.8-8.4 21.3.6.4 28.4 16.1.2.2 32 7.3.6.2.5-.8m6-20.4l-7.4 19.1-31-7.1-27.8-15.7 7.4-19.3 58.8 23z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M382.1 173.2l-15.9-6.1-12.2 31.6 15.7 6.1 12.4-31.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 173.1l-.4-.2-15.7-6.1h-.4l-.2.2-12.1 31.6-.2.4h.4l15.7 6.3h.4l.2-.2 12.1-31.6.2-.4m-13.1 31.1l-14.8-5.7 11.9-30.7 15.1 5.9-12.2 30.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M380.6 172.9l-.8-.4-12.2 31.5.6.2 12.4-31.3zM378.8 172l-.6-.2-12.3 31.6.8.2 12.1-31.6zM377.1 171.4l-.8-.2-12.1 31.4.6.4 12.3-31.6zM375.3 170.7l-.8-.4-12.3 31.6.8.2 12.3-31.4zM373.5 170.2l-.8-.4-12.1 31.6.8.2 12.1-31.4zM371.9 169.3l-.8-.2-12.3 31.4.8.4 12.3-31.6zM369.9 168.7l-.8-.2-12.1 31.4.8.4 12.1-31.6zM368.2 168.1l-.8-.4-12.4 31.5.8.2 12.4-31.3z",
    className: "st3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M324 150.6l-15.7-6.1-12.3 31.6 15.7 6.1 12.3-31.6z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M324.3 150.5l-.2-.2-15.9-6.1h-.2l-.2.2-12.3 31.6v.4h.2l15.9 6.3h.2l.2-.2 12.3-31.6v-.4m-13.1 31.1l-14.8-5.7 12.1-30.6 14.8 5.7-12.1 30.6z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 150.3l-.6-.4-12.3 31.6.8.2 12.1-31.4zM320.8 149.4l-.8-.2-12.1 31.6.6.2 12.3-31.6zM318.9 148.8l-.6-.2L306 180l.8.4 12.1-31.6zM317.3 148.2l-.8-.4-12.1 31.6.6.2 12.3-31.4zM315.4 147.6l-.6-.4-12.3 31.6.8.2 12.1-31.4zM313.7 146.7l-.8-.2-12.1 31.4.6.4 12.3-31.6zM311.9 146.1l-.6-.2-12.3 31.3.8.4 12.1-31.5zM310.2 145.5l-.8-.4-12.1 31.6.6.2 12.3-31.4z",
    className: "st3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M340.2 172.4c-.6-.3-1.3-.4-1.9-.4-2.4.1-4 1.2-5 3.3-.9 3.1.1 5.4 3.1 6.9.7.2 1.4.3 2 .3 2.2-.1 3.8-1.1 4.7-3.2 1-3.2 0-5.5-2.9-6.9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M343.6 179.6c.2-.8.3-1.5.4-2.1-.1-2.5-1.3-4.3-3.6-5.4-.8-.2-1.5-.3-2.1-.4-2.6.1-4.4 1.4-5.4 3.8-.2.6-.3 1.3-.4 2.1.1 2.4 1.3 4.2 3.8 5.2.6.2 1.3.3 2.1.4 2.4-.2 4.2-1.4 5.2-3.6m-5.2-7.1c.6 0 1.1.1 1.7.4 2 .8 3.1 2.4 3.1 4.6.1.5-.1 1-.4 1.7-.8 2-2.3 3.1-4.4 3.1-.6 0-1.3-.1-1.9-.4-2-.8-3.1-2.3-3.1-4.4 0-.6.1-1.3.4-1.9.9-2 2.4-3 4.6-3.1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5 114.7l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M334.4 119.7l2.1-5.4-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.6m-.1-4.5l-1.1 2.9-9.9-3.8 1.3-3 9.7 3.9z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M347 119.1l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M348 118.7l-.8-.2-12.1-4.8-.4.8-2.1 5.2.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1l-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 123.7l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M357.4 128.5l2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M370 128.1l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M371.1 127.7l-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1 1l-1.1 3.1-10-4 1.1-2.9 10 3.8z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 132.7l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 132.1l-.8-.2-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.2-.8m-2.1.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M393 137l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M391.8 142.8l2.1-5.2.2-.8-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M331.1 107.6l-5.4-2.1-1.7 4.8 5.2 1.9 1.9-4.6z",
    className: "st4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M332.1 107.2l-.8-.2-5.2-2.1-.8-.4-.2.8-1.9 4.6-.2.8 6.1 2.3.6.4.4-.8 1.7-4.6.3-.8m-7.1 2.6l1.1-3.1 3.8 1.5-1.3 3.1-3.6-1.5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 112.2l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7 111.6l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M354.1 116.6l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M355.1 116.2l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2.9l-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M365.6 121.1l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6 120.5l-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8.8.2 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2 1l-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M377.1 125.6l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M376 130.6l2.1-5.4-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.6m-.2-4.5l-1 2.9-9.9-3.8 1-3.1 9.9 4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M388.6 130l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M389.6 129.6l-.8-.2-12.1-4.8-.4.6-2.1 5.4.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9l-1.3 3-9.7-3.9 1-2.9 10 3.8z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M394.7 132.5l-6.3-2.5-1.7 4.8 6.1 2.3 1.9-4.6z",
    className: "st4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M395.9 132l-.8-.4-6.1-2.3-.8-.4-.4.8-1.7 4.6-.4.8.8.2 6.9 2.7.4-.6 1.7-4.8.4-.6m-8 2.2l1.3-3.1 4.6 1.9-1.3 2.9-4.6-1.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M338.9 105.5l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M340 104.9l-.8-.2-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.2-.8m-2.1.9l-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M350.4 109.9l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M349.2 115.5l2.1-5.2.2-.8-.6-.4-12.3-4.6-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1l-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M361.9 114.5l-11.5-4.6-1.9 4.6 11.7 4.6 1.7-4.6z",
    className: "st4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M362.8 114.8l.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1l-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 118.8l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M372.2 124.6l2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M385 123.3l-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    className: "st4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M385.8 123.7l.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1l-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5 127.8l-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M397.3 128.1l.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.3l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M334.7 98.4l-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    className: "st4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M335.7 98l-.8-.4-5.2-2.1-.8-.2-.2.8-1.9 4.6-.2.8.8.2 5.9 2.3.4-.6 2-5.4m-7 2.6l1-3.1 3.8 1.5-1.1 2.9-3.7-1.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M346.1 102.8l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M347.2 102.4l-.8-.2-12.1-4.8-.4.8-2.1 5.2.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9l-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M357.7 107.3l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M356.6 112.2l2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2 111.8l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M370.2 111.4l-.8-.4-12.1-4.6-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9l-1.1 3.1-10-4 1.1-2.9 10 3.8z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M380.7 116.4l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M381.7 115.8l-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 120.7l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M390.9 126.4l2.3-6.1-.6-.4-11.7-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M398.3 123.3l-6.3-2.5-1.7 4.6 6.1 2.5 1.9-4.6z",
    className: "st4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4 122.7l-.8-.2-6.1-2.5-.8-.2-.2.8-1.9 4.6-.2.8 6.9 2.7.8.2.2-.8 1.9-4.6.2-.8m-8.1 2.4l1.3-3.1 4.6 1.7-1.1 3.1-4.8-1.7z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 96.1l-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    className: "st4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 96.6l.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.8.1l-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M354.1 100.7l-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M353 105.5l2.1-5.2-.6-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m0-4.3l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M365.6 105l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M366.8 104.6l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.9m-2.2 1l-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M377.1 109.6l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M378.4 109.1l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.8m-2.2 1l-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M388.6 114.1l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M389.9 113.7l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2.9l-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M400 118.4l-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    className: "st4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M401.2 118l-.8-.2-11.5-4.6-.9-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.4-.8 1.7-4.6.5-.8m-2.2 1l-1.3 3.1-9.8-3.9 1.1-3 10 3.8z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M338.1 89.2l-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    className: "st4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M338.9 89.4l.2-.8-6.7-2.5-.4.6-2.1 5.4.8.4 5.2 2.1.8.2.2-.8 2-4.6m-6.8 1.8l1.1-2.9 3.7 1.3-1 3.1-3.8-1.5z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M349.6 93.6l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M348.3 99.2l2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1l-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M361.1 98.2l-11.5-4.6-1.9 4.6 11.7 4.6 1.7-4.6z",
    className: "st4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M361.9 98.5l.2-.8-12.1-4.9-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.5m-1.9.1l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M372.8 102.6l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M371.3 108.2l2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.1-5.2l-1 3-10-3.8 1.3-3.1 9.7 3.9z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M384.2 107l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M385 107.5l.2-.8-12.1-4.8-.8-.2-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.8.1l-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M395.7 111.6l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5 111.8l.2-.8-12.1-4.6-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.8.1l-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M402 113.9l-6.1-2.3-1.9 4.6 6.1 2.3 1.9-4.6z",
    className: "st4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M402.8 114.3l.2-.8-6.9-2.7-.8-.2-2.3 6.1.8.4 6.1 2.3.8.4.2-.8 1.9-4.7m-7.7 1.4l1.1-2.9 4.6 1.7-1 3.1-4.7-1.9z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M346.1 86.9l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M347.3 86.5l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1l-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M357.8 91.5l-11.7-4.6-1.7 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M358.8 90.9l-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2 95.8l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M370.3 95.5l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 13 5 .4-.6 1.7-4.8.3-.6m-2.2 1l-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M380.7 100.2l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M381.8 99.8l-.8-.2-11.6-4.6-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.5-.8m-2.2.9l-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M392.3 104.9l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M393.3 104.5l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.6m-2.3.9l-1.1 2.9-9.9-3.8 1.1-3.1 9.9 4z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M403.8 109.3l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8 108.9l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M341.8 79.8l-5.2-1.9-1.9 4.6 5.4 2.1 1.7-4.8z",
    className: "st4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 80.2l.2-.8-5.9-2.3-.8-.4-.4.8-1.7 4.6-.4.8.8.2 5.2 2.1.8.4.2-.8 2-4.6m-6.8 1.8l1.3-3.1 3.8 1.5-1.3 3.1-3.8-1.5z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M353.2 84.4l-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M354.6 84l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.4-.6m-2.3.9l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M364.8 88.8l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M366 88.4l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.9m-2.2 1l-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M376.3 93.4l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M377.5 92.8l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.3.8 12.1 4.8.9.2.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M387.8 97.7l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M389 97.4l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1l-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5 102.1l-11.7-4.4-1.7 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5 101.7l-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.8-3.9 1.1-3 10 3.8z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M405.5 104.7l-6.1-2.3-1.9 4.6 6.3 2.3 1.7-4.6z",
    className: "st4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M406.8 104.3l-.8-.4-6.3-2.3-.6-.4-.4.8-1.9 4.6-.2.8.8.2 6.1 2.5.8.2 2.1-5.2.4-.8m-8.1 2.2l1.3-3 4.6 1.8-1.3 3-4.6-1.8z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M349.9 77.3l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M351.2 76.9l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.8.4-.6m-2.2 1l-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M361.5 81.7L350 77.3l-1.7 4.6 11.5 4.6 1.7-4.8z",
    className: "st4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M362.7 81.3l-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.8m-2.2.9l-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1 86.3l-11.7-4.6-1.7 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M374.2 85.9l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.6m-2.3.9l-1.1 2.9-9.9-3.8 1.1-3.1 9.9 4z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M384.6 90.7l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M385.6 90.3l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.9m-2.2.9l-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M396 95.3l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M397.1 94.7l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 13 5 .4-.8 1.7-4.6.3-.8m-2.2.9l-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5 99.6L396 95.2l-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M408.6 99.2l-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2 1l-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M345.4 70.2l-5.2-2.1-1.9 4.8 5.4 1.9 1.7-4.6z",
    className: "st4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M346.2 70.6l.2-.8-6.1-2.3-.6-.4-.4.8-1.7 4.6-.4.8.8.2 5.2 2.1.8.4.2-.8 2-4.6m-6.8 1.8l1.3-3.1 3.7 1.5-1.1 3.1-3.9-1.5z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M357 74.8l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M357.8 75l.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.8.1l-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M368.5 79.1L357 74.8l-1.7 4.6 11.5 4.4 1.7-4.7z",
    className: "st4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M367.2 84.8l2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-2.1 5.2-.4.8.8.4 11.5 4.4.8.2m.3-5.1l-1.3 3.1-10-4 1.3-3.1 10 4z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M380.1 83.7l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 83.1l-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.2-.8 1.9-4.6.4-.8m-2.2.9l-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M391.6 88.2l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8 87.8l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.6 1.7-4.8.4-.6m-2.3.9l-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M403 92.5l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M404.3 92.1l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4L401 98l.8.4.4-.8 1.7-4.6.4-.9m-2.2 1l-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M409.3 95.1l-6.1-2.5-1.9 4.8 6.3 2.3 1.7-4.6z",
    className: "st4"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M410.3 94.6l-.6-.4-6.3-2.3-.8-.4-.2.8-1.9 4.6-.2.8.8.2 6.1 2.5.8.2 2.3-6m-7.8 2.2l1-3.1 4.7 1.9-1.1 2.9-4.6-1.7z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M366 164.6l-39.7-15.5-6.5 18.2 38.5 15.1 7.7-17.8z",
    className: "st5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M357.4 173.4l-29.9-11.5-2.3 5.9 29.9 11.7 2.3-6.1z",
    className: "st1"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7",
    transform: "matrix(.9321 .3625 -.3625 .932 325.9068 167.1001)"
  }, "\n    L521 GHF\n  ")), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 142.3l75.5 29.5-1.5 8.8 12.5-37.4-75.9-29.5-15.9 36 5.3-7.4z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M392.6 144.4l-72.3-28.2-4.6 20.1 66.9 25.9 10-17.8z",
    className: "st2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M442.1 129.5c-1.1-.4-2.3-.6-3.4-.6-4 .1-6.9 2.2-8.7 6.1l-14.2 36.4 71.9 28 14.2-36.4c1.6-5.6-.2-9.8-5.4-12.3l-54.4-21.2z",
    className: "st1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M502.8 163.2c.4-1.3.6-2.5.6-3.8-.2-4.4-2.4-7.6-6.5-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.6.1-7.8 2.3-9.6 6.5L415 171.2l-.2.8 72.8 28.2.8.2 14.4-37.2m-1.1-3.7c0 1-.2 2.1-.6 3.1l-13.7 35.9-70.7-27.4 13.9-35.9c1.7-3.5 4.4-5.3 8.2-5.4 1 0 2.1.2 3.1.6l54.4 21.1c3.5 1.6 5.3 4.3 5.4 8z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 155.7l-47-18.2-5.4 14.2 47 18.2 5.4-14.2z",
    className: "st1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M486.6 170.9l5.9-14.8.2-.8-47.7-18.6-.8-.2-5.9 14.8-.2.8.6.4 47 18.2.9.2m3.8-14.7l-4.8 12.8-45.4-17.8 4.8-12.5 45.4 17.5zM505.3 175.8l-.2-1.7-9.6.8.2 1.7 9.6-.8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M510.6 171.2l-6.5-2.5-5 13 6.5 2.5 5-13z",
    className: "st1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M511.7 170.8l-.8-.4-6.5-2.5-.8-.2-.2.8-5 13-.4.8.8.2 6.5 2.5.8.4.2-.8 5.2-13 .2-.8m-6.5 12.4l-5-1.9 4.4-11.5 5 1.9-4.4 11.5zM426.7 148.2l-6.5-7.1-1.3 1 6.5 7.3 1.3-1.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M424.6 137.7l-6.5-2.5-5.2 13 6.5 2.5 5.2-13z",
    className: "st1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M425.6 137.1l-.8-.2-6.5-2.5-.8-.4-.2.8-5 13-.4.8.8.4 6.5 2.5.8.2.2-.8 5-13 .4-.8m-6.6 12.5l-5-1.9 4.4-11.5 5 1.9-4.4 11.5z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M419.1 181.6l-7.9 20.7 28.4 16.1 32 7.3 7.9-20.7-60.4-23.4z",
    className: "st2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M472 226.7l8.4-21.3.4-.8-.8-.2-60.4-23.6-.8-.2-8.6 22.2.6.2 28.4 16.3h.2l32 7.3.6.1m6.6-21.2l-7.5 19.1-31.3-7.1v.1L412.2 202l7.4-19.2 59 22.7z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M483.6 212.9l-15.7-6.3-12.1 31.6 15.7 6.1 12.1-31.4z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M484.3 212.7l-.4-.2-15.7-6.1-.4-.2-.2.4-12.1 31.4-.2.4.4.2 15.7 6.1.4.2.2-.4 12.1-31.6.2-.2m-13 31.1l-14.8-5.7 11.8-30.8 14.9 6-11.9 30.5z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M482.4 212.3l-.8-.2-12.1 31.4.6.4 12.3-31.6zM480.6 211.7l-.6-.4-12.3 31.6.8.2 12.1-31.4zM478.9 211.1l-.8-.4-12.1 31.5.6.2 12.3-31.3zM477.2 210.2l-.8-.2-12.4 31.4.8.4 12.4-31.6zM475.4 209.6l-.8-.2-12.1 31.4.8.4 12.1-31.6zM473.6 209l-.8-.4-12.3 31.6.8.2 12.3-31.4zM471.9 208.2l-.9-.2-12.1 31.4.8.4 12.2-31.6zM470 207.5l-.8-.2-12.3 31.4.8.4 12.3-31.6z",
    className: "st3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M425.7 190.4l-15.7-6.3-12.3 31.6 15.7 6.1 12.3-31.4z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M426.3 190.2l-.2-.2-15.9-6.1-.4-.2v.4l-12.3 31.4-.2.4.4.2 15.9 6.1.2.2.2-.4 12.3-31.6v-.2m-13 31.1l-14.8-5.9 11.8-30.7 14.9 6-11.9 30.6z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M424.3 189.7l-.8-.2-12.1 31.4.8.4 12.1-31.6zM422.7 189.1l-.8-.4-12.3 31.6.8.2 12.3-31.4zM420.7 188.5l-.6-.4-12.3 31.6.8.2 12.1-31.4zM419 187.6l-.8-.2-12.2 31.4.6.4 12.4-31.6zM417.3 187l-.6-.2-12.3 31.4.8.4 12.1-31.6zM415.5 186.4l-.8-.4-12.1 31.6.6.2 12.3-31.4zM413.7 185.6l-.6-.2-12.3 31.4.8.4 12.1-31.6zM412.1 184.9l-.8-.2-12.1 31.4.6.4 12.3-31.6z",
    className: "st3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M442.1 211.8c-.6-.2-1.3-.3-1.9-.3-2.4.1-4 1.2-5 3.4-1 3.1 0 5.4 2.9 6.9.6.3 1.3.4 1.9.3 2.4-.1 4-1.2 5-3.4.9-3.1-.1-5.4-2.9-6.9z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M445.4 219c.3-.7.4-1.4.4-2.1-.1-2.4-1.3-4.2-3.6-5.2-.8-.3-1.5-.5-2.1-.4-2.5.1-4.3 1.3-5.4 3.6-.2.7-.3 1.4-.4 2.1.1 2.5 1.4 4.3 3.8 5.2.6.3 1.3.5 2.1.4 2.5 0 4.2-1.2 5.2-3.6m-5.2-6.9c.4-.1 1 0 1.7.2 2 1 3.1 2.6 3.1 4.6 0 .7-.1 1.3-.4 1.7-.8 2.1-2.3 3.1-4.4 3.1-.6.1-1.3 0-1.9-.2-2-1-3-2.5-3.1-4.6.1-.6.2-1.2.4-1.7.9-2 2.4-3.1 4.6-3.1z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M437.2 154.2l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3 153.8l-.8-.2L426 149l-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.9-4.6.2-.8m-2.2 1l-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M448.7 158.8l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M447.7 163.6l2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3l-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M460.2 163.2l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M461.2 162.8l-.8-.4-12.1-4.6-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9l-1 3.1-10-4 1.1-2.9 9.9 3.8z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M471.7 167.8l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M472.7 167.2l-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1l-1 3.1-10-3.8 1.3-3.1 9.7 3.8z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M483.2 172.1l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M481.9 177.8l2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1l-1.1 2.9-10-3.8 1.3-3 9.8 3.9z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M494.7 176.6l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M495.8 176.2l-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9l-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 147.2l-5.4-2.1-1.7 4.6 5.2 2.1 1.9-4.6z",
    className: "st4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M433.9 146.7l-.8-.2-5.2-2.1-.8-.2-2.3 6.1.6.4 6.1 2.3.4-.8 1.7-4.6.3-.9m-7.2 2.6l1.3-3 3.8 1.4-1.3 3.1-3.8-1.5z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 151.6l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M445.5 151.3l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2 1l-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M455.9 156.1l-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    className: "st4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M456.9 155.7l-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2 1l-1.3 3-9.8-3.8 1.1-3 10 3.8z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M467.4 160.7l-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M468.5 160.3l-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.6m-2.3.9l-1 2.9-9.9-3.8 1-3.1 9.9 4z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M478.9 165.1l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M480 164.6l-.8-.2-11.5-4.6-.8-.2-2.3 6.1.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.9m-2.2 1l-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M490.4 169.6l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M491.5 169.1l-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.9-4.6.2-.8m-2.2 1l-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M496.6 172l-6.3-2.3-1.7 4.6 6.1 2.3 1.9-4.6z",
    className: "st4"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M497.7 171.6l-.8-.2-6.1-2.5-.8-.2-.4.6-1.7 4.8-.4.6.8.4 6.3 2.3.6.4.4-.8 1.7-4.6.4-.8m-8 2.2l1.3-3 4.6 1.8-1.3 3.1-4.6-1.9z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M440.9 145l-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    className: "st4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M439.6 150.7l2.1-5.2.2-.8-.8-.4-12.1-4.6-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1l-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M452.4 149.6l-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    className: "st4"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M453.2 149.8l.2-.8-13-5-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 2-4.6m-1.9.1l-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M463.8 154l-11.5-4.4-1.9 4.6 11.7 4.4 1.7-4.6z",
    className: "st4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M462.6 159.6l2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.1-5.2l-1 3-10-3.8 1.3-3.1 9.7 3.9z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M475.3 158.5l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M476.2 158.9l.2-.8-12.1-4.8-.8-.2-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1l-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8 163l-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    className: "st4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M487.7 163.3l.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.1l-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M498.3 167.4l-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    className: "st4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M497.1 173l2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.3-5.1l-1.3 3.1-10-4 1.3-3.1 10 4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M467.8 204.2l-39.7-15.5-6.5 18.4 38.5 15.1 7.7-18z",
    className: "st5"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M459.1 213.3l-29.9-11.7-2.3 6.1 29.9 11.5 2.3-5.9z",
    className: "st1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7",
    transform: "matrix(.9321 .3625 -.3625 .932 427.7067 206.5995)"
  }, "\n    L521 GHF\n  ")), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M410.2 182l75.5 29.3-1.5 8.8 12.5-37.2-75.9-29.5-15.9 36 5.3-7.4z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M494.4 183.8L422 155.6l-4.6 20.1 66.9 26.1 10.1-18z",
    className: "st2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5 259.6v-12.3H479.1l-292.2-114H82.6v126.3h634.9z",
    className: "st4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5 248.2v-1.7H479.1v.1l-291.9-114H82.6v1.7h104.1l292.1 113.9h238.7z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 46.7c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    className: "st8"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st6 st9",
    transform: "matrix(.998 0 0 1 374.9043 61.2539)"
  }, "\n    2\n  ")), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M284.9 32.7c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    className: "st8"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st6 st9",
    transform: "matrix(.998 0 0 1 271.6045 47.2539)"
  }, "\n    1\n  ")), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M487.7 107.9c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    className: "st8"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st6 st9",
    transform: "matrix(.998 0 0 1 474.4043 122.4541)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/e2.cb35408441144edb0980c3a58dc51fb6.svg";
export { ForwardRef as ReactComponent };